import { useState } from "react"
import Input, { required, submitForm, useInput, useToggleInput } from "../../../components/input"
import LoadingButton from "../../../components/LoadingButton"
import { api } from "../../../env"

export default function DirectInviteCard({ programId }) {

    const [isLoading, setIsLoading] = useState(false)

    const inviteForm = {
        email: useInput("Email", "email", "email", [required]),
        type: useToggleInput("Role", "group", true, [{key: "Mentor", label: "Mentor"}, {key: "Mentee", label: "Mentee"}])
    }

    const handleInvite = () => {
        let inviteInfo = submitForm(inviteForm)
        if (!inviteInfo) return
        setIsLoading(true)
        api.post(`programs/${programId}/invitations`, inviteInfo)
            .then(() => setIsLoading(false))
            .catch(() => setIsLoading(false))
    }

    return (
        <div className="card flex columns space-between gap-xs">
            <div className="flex columns gap-xs">
            <p className="section-title-s">Direct invite</p>
            <p className="label-m o-50">Send a personal email to specific people. They click a link and join.</p>
            <Input state={inviteForm.email} />
            <Input state={inviteForm.type} />
            </div>
            
            <div className="flex justify-end">
                <LoadingButton className="solid large" label="Send invite" isLoading={isLoading} onClick={handleInvite} />
            </div>
        </div>
    )
}
